<a *ngIf="imageUrl" [attr.href]="linkHref" target="_blank" rel="noopener noreferrer" (click)="trackLinkClick()">
  <img [src]="imageUrl" [alt]="altText">
</a>
<div *ngIf="!imageUrl">
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="300px" height="300px" viewBox="0 0 500 500">
    <path fill="#777777" d="M182.315,196.75v106.5h135.37v-106.5H182.315L182.315,196.75z M306.78,291.703H193.864v-83.404H306.78   V291.703L306.78,291.703z"/>
    <polygon fill="#777777" points="199.715,282.865 223.088,258.295 231.847,262.088 259.477,232.661 270.358,245.676    275.262,242.711 301.827,282.865  "/>
    <circle fill="#777777" cx="226.719" cy="229.417" r="10.21"/>
  </svg>
</div>
